import {
  FETCH_DISCREPANCY,
  FETCH_DISCREPANCY_FAILURE,
  FETCH_DISCREPANCY_SUCCESS,
  UPDATE_FILTERS,
  UPDATE_WEEK,
  TOGGLE_MODAL,
  APPROVE_CLOCK,
  APPROVE_CLOCK_SUCCESS,
  APPROVE_CLOCK_FAILURE,
  UPDATE_LIST,
  TOGGLE_UNAPPROVE,
} from "./constants";

export const fetchDiscrepancy = (payload, onSuccess) => ({
  type: FETCH_DISCREPANCY,
  payload,
  onSuccess,
});
export const fetchDiscrepancySuccess = (payload) => ({
  type: FETCH_DISCREPANCY_SUCCESS,
  payload,
});
export const fetchDiscrepancyFailure = (payload) => ({
  type: FETCH_DISCREPANCY_FAILURE,
  payload,
});
export const updateFilters = (payload) => ({
  type: UPDATE_FILTERS,
  payload,
});
export const updateWeek = (payload) => ({
  type: UPDATE_WEEK,
  payload,
});
export const toggleModal = (payload) => ({
  type: TOGGLE_MODAL,
  payload,
});
export const approveClock = (payload, onSuccess) => ({
  type: APPROVE_CLOCK,
  payload,
  onSuccess,
});
export const approveClockSuccess = (payload) => ({
  type: APPROVE_CLOCK_SUCCESS,
  payload,
});
export const approveClockFailure = (payload) => ({
  type: APPROVE_CLOCK_FAILURE,
  payload,
});
export const updateList = (payload) => ({
  type: UPDATE_LIST,
  payload,
});

export const toggleUnapprove = (payload) => ({
  type: TOGGLE_UNAPPROVE,
  payload,
});
